import { useEffect, useState } from 'react';
import './CookiePoliciesBannerStyles.scss';
import Close from '../../../assets/Close';
export const HIDE_COOKIE_BANNER_STORAGE_KEY = 'main-hide-cookie-policy';

function CookiePoliciesBanner() {
  const [hideCookieBanner, setHideCookieBanner] = useState<any>();

  useEffect(() => {
    setHideCookieBanner(sessionStorage.getItem(HIDE_COOKIE_BANNER_STORAGE_KEY));
  }, []);

  function closeBanner() {
    sessionStorage.setItem(HIDE_COOKIE_BANNER_STORAGE_KEY, 'false');
    setHideCookieBanner(true);
  }

  return (
    <>
      {!hideCookieBanner && (
        <div className="policies-banner">
          <div className="content">
            <span>
              By using this website, you agree to our use of cookies, our <a href="/cookie-policy">cookie policy</a> and our{' '}
              <a href="/privacy-notice">privacy notice</a>. We use cookies to provide you with a great experience and to help our website run
              effectively.
            </span>
          </div>
          <div className="button-container">
            <Close onClick={() => closeBanner()} className="close-button" />
          </div>
        </div>
      )}
    </>
  );
}
export default CookiePoliciesBanner;
